import { useQuery } from "@tanstack/react-query";
import firebaseService from "../../firebase_service/firebaseService";
import { SWISS_CLOCK_IDFS } from "../../views/Dashboard/swissClocks";

/**
 * Hook to count how many of the Swiss clock batch have been "opened"
 * (registered), i.e. their machine doc has `registerProduct.value === true`.
 */
const useOpenedSwissClocksCount = () =>
  useQuery({
    queryKey: ["openedSwissClocksCount"],
    queryFn: () => firebaseService.countRegisteredByIdfs(SWISS_CLOCK_IDFS),
    staleTime: 5 * 60 * 1000,
  });

export default useOpenedSwissClocksCount;
